import { SVGProps } from 'react';

const BookUp2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 13V7m3 3-3-3-3 3M6.5 2A2.5 2.5 0 0 0 4 4.5v15A2.5 2.5 0 0 0 6.5 22H19a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-1M4 19.5A2.5 2.5 0 0 1 6.5 17H20M9 5l3-3 3 3"
    />
  </svg>
);
export default BookUp2;
